<template>
  <div class="project-table">
    <v-data-table
      :loading="loading"
      :headers="tableHeaders"
      :items="projects"
      :options.sync="pagination"
      :items-per-page="pagination.itemsPerPage"
      :server-items-length="totalProjects"
      :footer-props="{
        itemsPerPageOptions: [10, 100, 1000]
      }"
      @click:row="handleRowClick"
    >
      <template #item.idc_recorded_admin_file="{ item }">
        <v-icon v-if="item.idc_recorded_admin_file"
          >mdi-checkbox-marked-circle</v-icon
        >
      </template>

      <template #item.idc_printed_sheet="{ value }">
        <v-icon v-if="value">mdi-checkbox-marked-circle</v-icon>
      </template>

      <template #item.product_uuid="{ item }">
        <v-icon v-if="!item.product_uuid">mdi-alert</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AppProjectTable",

  data() {
    return {
      tableHeaders: [
        {
          text: "Patient",
          sortable: true,
          value: "patient.fullname"
        },
        {
          text: "Type",
          sortable: true,
          value: "product_name"
        },
        {
          text: "Lu",
          sortable: true,
          value: "idc_recorded_admin_file"
        },

        {
          text: "Imprimé",
          sortable: true,
          value: "idc_printed_sheet"
        },

        {
          text: "Erreur Sync",
          sortable: true,
          value: "product_uuid"
        },
        {
          text: "Créé",
          sortable: true,
          value: "created_at"
        },
        {
          text: "Transféré",
          sortable: true,
          value: "initial_transfer_at"
        },
        {
          text: "Arrivée de moulage",
          sortable: true,
          value: "molding_arrival_at"
        },
        {
          text: "Applicateur",
          sortable: true,
          value: "applicator.fullname"
        }
      ],

      loading: false
    };
  },

  computed: {
    ...mapState({
      totalProjects: state => state.projects.totalItems
    }),

    ...mapGetters({
      projects: "projects/projects"
    }),

    pagination: {
      get() {
        return this.$store.state.projects.pagination;
      },

      set(value) {
        this.$store.commit("projects/SET_PAGINATION", value);
      }
    }
  },

  watch: {
    pagination: {
      handler() {
        this.loading = true;
        this.$store.dispatch("projects/fetchProjects").then(() => {
          this.loading = false;
        });
      },
      deep: true
    }
  },

  methods: {
    handleRowClick(item) {
      this.$emit("click:row", item);
    }
  }
};
</script>

<style></style>
